<script>
    import {onMount} from "svelte";
    import {get_order} from "../events";

    import Footer from '../components/Footer.svelte';

    let promise = null
    let paying = false

    onMount(async () => {
        promise = get_order(location.query.order, location.query.orderStr, location.query.vid || 16)
    })

    const handle = async () => {
        if (paying) {
            return
        }
        paying = true
        const data = await promise;

        try {
            const receipt = {
                "customer": {
                    "name": data.recipient.fio || "",
                    "email": data.recipient.email || "",
                    "phone": (data.recipient.tel || '').replace(/\D/g, '')
                },
                "amount": data.items.reduce((sum, item) => sum + (item.price.rozn * item.quantity), 0),
                "items": data.items.map(item => ({
                    "description": item.name,
                    "quantity": item.quantity.toFixed(3),
                    "amount": (+item.price.rozn).toFixed(2),
                })),
                "order": location.query.order,
                "orderStr": location.query.orderStr
            }

            const response = await fetch('/payment/create.php', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(receipt)
            });

            const result = await response.json();

            if (result.confirmation_url) {
                window.location.href = result.confirmation_url;
            } else {
                alert('Ошибка при создании платежа: ' + (result.error || 'Неизвестная ошибка'));
            }
        } catch (e) {
            console.error("Ошибка сети:", e);
            alert("Не удалось связаться с сервером оплаты.");
        } finally {
            paying = false
        }
    }
</script>

<div id="appCapsule" style="padding: 0 0 10px 0">
    <div class="section mt-2">
        {#if promise}
            {#await promise}
                <div class="text-center p-3">
                    <div class="spinner-border text-primary" role="status"></div>
                    <p>Загрузка заказа...</p>
                </div>
            {:then data}
                {#if data && typeof data === 'object' && data.items}
                    {@const totalSum = data.items.reduce((sum, item) => sum + (item.price.rozn * item.quantity), 0)}

                    {#if totalSum > 0}
                        <div class="card">
                            <div class="card-body">
                                <h3 class="card-title">Данные получателя</h3>
                                <p class="mb-1"><strong>ФИО:</strong> {data.recipient.fio}</p>
                                {#if data.recipient.tel}
                                    <p class="mb-1"><strong>Телефон:</strong> {data.recipient.tel}</p>
                                {/if}
                                {#if data.recipient.email}
                                    <p class="mb-1"><strong>Email:</strong> {data.recipient.email}</p>
                                {/if}
                            </div>
                        </div>

                        <div class="row mt-1">
                            {#each data.items as item}
                                <div class="col-12 mb-1">
                                    <div class="card">
                                        <div class="card-body">
                                            <h4 class="mb-1">{item.name}</h4>
                                            <p class="text-muted small mb-1">{item.title}</p>
                                            <div class="d-flex justify-content-between align-items-center">
                                                <span>{item.quantity} шт. x {Math.round(item.price.rozn).toLocaleString()}₽</span>
                                                <span class="h4 mb-0">
                                                    {Math.round(item.price.rozn * item.quantity).toLocaleString()}₽
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            {/each}
                        </div>

                        <div class="card mt-1 border-primary">
                            <div class="card-body text-center">
                                <h2 class="mb-1">Итого к оплате:</h2>
                                <h1 class="text-primary mb-3">{Math.round(totalSum).toLocaleString()}₽</h1>

                                <button type="button" class="btn btn-success btn-lg btn-block" on:click={handle} disabled={paying}>
                                    {paying ? 'Отправка...' : 'Оплатить'}
                                </button>
                            </div>
                        </div>
                    {:else}
                        <div class="section mt-2">
                            <div class="card border-danger">
                                <div class="card-body text-center p-3">
                                    <div class="mb-2">
                                        <i class="fas fa-exclamation-circle text-primary" style="font-size: 2rem;"></i>
                                    </div>
                                    <h3 class="text-primary">Заказ уже оплачен</h3>
                                </div>
                            </div>
                        </div>
                    {/if}
                {:else}
                    <div class="section mt-2">
                        <div class="card border-danger">
                            <div class="card-body text-center p-3">
                                <div class="mb-2">
                                    <i class="fas fa-exclamation-circle text-danger" style="font-size: 2rem;"></i>
                                </div>
                                <h3 class="text-danger">Ошибка</h3>
                                <p class="mb-0">К сожалению, заказ не найден или был удален.</p>
                            </div>
                        </div>
                    </div>
                {/if}
            {/await}
        {/if}
    </div>
</div>

<Footer />

<style>
    .card-body {
        padding: 10px;
    }

    .card-title {
        border-bottom: 1px solid #eee;
        padding-bottom: 5px;
        font-size: 16px;
    }

    .text-primary {
        font-weight: 700;
    }
</style>

